export default __webpack_public_path__ + "static/media/light_rank2.af32ba68.svg";